module.exports = __webpack_public_path__ + "static/media/cover-product-4.666aeba3.jpg";